export default __webpack_public_path__ + "static/media/birthday-gray.bfb5385e.svg";